import { useState, useEffect } from 'react'
import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'
import RatesCalloutWrapper from '../helpers/RatesCalloutWrapper'

function RatesCalloutBanner(props) {
  const [hasProducts, setHasProducts] = useState(false)
  const [textAlignment, setTextAlignment] = useState({
    flex: 'center',
    align: 'center',
  })
  const componentPadding = transformPaddingToTailwind(props.componentPadding, true)

  useEffect(() => {
    setHasProducts(props.products?.length > 0)
  }, props.products)

  useEffect(() => {
    setTextAlignment((prevState) => {
      const newState = { ...prevState }
      const alignment = props.contentAlignment?.toLowerCase() ?? 'center'
      if (newState.align !== props.contentAlignment?.toLowerCase()) {
        newState.flex = alignment === 'center' ? 'center' : 'start'
        newState.align = alignment === 'center' ? 'center' : 'left'
      }
      return newState
    })
  }, [])

  return (
    <>
      <Section
        {...props}
        type="heroBanner"
        data-variant="withRatesCallout"
        sectionTitle={false}
        mobileBackgroundImage={props.mobileImage}
        desktopBackgroundImage={props.desktopImage}
        innerClass={`flex justify-${textAlignment.flex} ${componentPadding.top} ${hasProducts ? componentPadding.mid : componentPadding.bottom}`}
      >
        <div className={`mx-6 max-w-3xl text-${textAlignment.align}`}>
          {(props.title || props.description) && <TitleBlock {...props} />}
          {props.ctaLinks.length != 0 && (
            <div className={`flex justify-${textAlignment.flex} max-lg:flex-wrap max-lg:space-y-6 space-x-6 mt-10`}>
              {props.ctaLinks.map((ctaLinkItem, i) => (
                <ButtonEl
                  link={ctaLinkItem.link}
                  theme={ctaLinkItem.linkType.toLowerCase()}
                  icon={ctaLinkItem.linkIconClass}
                />
              ))}
            </div>
          )}
        </div>
      </Section>
      {props.products?.length && (
        <section
          data-type="embeddedRatesCallout"
          className={`${componentPadding.card} ${componentPadding.bottom} container mx-auto relative z-[10]`}
        >
          <RatesCalloutWrapper
            {...props}
            rate={props.products[0]}
            title={props.ratesCardTitle}
            description={props.ratesCardDescription}
            embedded="true"
            className="bg-white text-shadow-off"
          />
        </section>
      )}
    </>
  )
}

export default RatesCalloutBanner
